import React from 'react';
import { Button, Stack, Typography } from '@mui/material';

interface Props<Context extends any = any> {
  context: Context;
  selected: string[];
  onClose: VoidFunction;
  bulkActions: (renderProps: { context: Context; selected: string[]; onClose: VoidFunction }) => React.ReactNode;
}

export const BulkActionsPanel = <Context extends any = any>({
  context,
  selected,
  onClose,
  bulkActions,
}: Props<Context>) => {
  return (
    <Stack
      sx={{
        alignItems: 'center',
        flexDirection: 'row',
        borderRadius: '0.3rem',
        backgroundColor: 'black',
        padding: '0.3rem 0.5rem',
        justifyContent: 'space-between',
      }}
    >
      <Stack direction="row" gap="0.5rem" alignItems="baseline">
        {!!selected.length && <Typography sx={{ color: 'white' }}>{selected.length} selected</Typography>}

        {bulkActions({ context, selected, onClose })}
      </Stack>

      <Button size="small" variant="text" sx={{ color: 'white' }} onClick={onClose}>
        Cancel
      </Button>
    </Stack>
  );
};
